"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _isEmpty = _interopRequireDefault(require("lodash/isEmpty"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getStatesByCountry = function getStatesByCountry(countries, countryCode) {
  var _countries$find;

  var states = countries === null || countries === void 0 ? void 0 : (_countries$find = countries.find(function (country) {
    return country.isoCode === countryCode;
  })) === null || _countries$find === void 0 ? void 0 : _countries$find.states;
  if ((0, _isEmpty.default)(states)) return;
  return states;
};

var _default = getStatesByCountry;
exports.default = _default;